import { FeatureFlagCookie } from 'views/utils/experiments/types'
import { getCookieByName } from 'shared/utils/getCookie'
import { FEATURE_FLAG_COOKIE } from 'shared/consts/featureFlagCookie'

export function getFeatureFlagCookie(
  cookie: string
): FeatureFlagCookie | undefined {
  const featureFlagCookie: string = getCookieByName(FEATURE_FLAG_COOKIE, cookie)

  if (!featureFlagCookie) {
    return undefined
  }

  return JSON.parse(featureFlagCookie)
}
